import React from 'react';

import styled from 'styled-components';

import { Row, Col } from 'react-bootstrap';

import { Carousel } from '@zanichelli/react-components';

const MaxWidthRow = styled(Row)`
    max-width: 1200px;
    margin: auto;
`;

const StatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 16px 40px;
`;

const Number = styled.span`
    font-size: 32px;
    font-weight: 600;
`;

const Stat = styled.span`
    white-space: nowrap;
    font-size: 24px;
`;

const Div = styled.div``;

const Stats = () => {
    const ResponsiveCarousel = window.innerWidth < 768 ? Carousel : Div;

    return (
        <MaxWidthRow>
            <ResponsiveCarousel>
                <Col xs={12} sm={4}>
                    <StatsContainer>
                        <Number>{'28'}</Number>
                        <Stat>{'materie presenti'}</Stat>
                    </StatsContainer>
                </Col>
                <Col xs={12} sm={4}>
                    <StatsContainer>
                        <Number>{'30.000+'}</Number>
                        <Stat>{'esercizi'}</Stat>
                    </StatsContainer>
                </Col>
                <Col xs={12} sm={4}>
                    <StatsContainer>
                        <Number>{'12.000+'}</Number>
                        <Stat>{'verifiche pronte'}</Stat>
                    </StatsContainer>
                </Col>
            </ResponsiveCarousel>
        </MaxWidthRow>
    );
};

export default Stats;
